export default __webpack_public_path__ + "2cbb9c6806852db129ea3341f52bb0ae.jpg";